// Reusable debounce utility — add once at the top of custom.js:
function debounce(fn, delay = 150) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


/* Tab Start */
function InitTabs() {
  document.querySelectorAll(".Tabs_common_main_new").forEach(container => {

        const tabs = container.querySelectorAll(".Tabs_common_inner_new");
        const contents = container.querySelectorAll(".tabcontent");

        const group = container.querySelector("[data-tab-group]");
        const bg = group ? group.querySelector(".tab_background_new") : null;

        function moveBgToTab(tab) {
            if (!group || !bg) return;

            const tabsArr = Array.from(tabs);
            const isLast = tab === tabsArr[tabsArr.length - 1];

            const tabRect = tab.getBoundingClientRect();
            const groupRect = group.getBoundingClientRect();

            let offset = tabRect.left - groupRect.left;

            // 3px gap on last tab
            if (isLast) offset -= 0;

            bg.style.width = `${tabRect.width}px`;
            bg.style.transform = `translateX(${offset}px)`;
        }

        function activateTab(tab) {
          const tabId = tab.getAttribute("tab_id");
          if (!tabId) return;

          tabs.forEach(t => t.classList.remove("active"));
          contents.forEach(c => c.style.display = "none");
          contents.forEach(c => c.classList.remove("active"));

          tab.classList.add("active");

          const targets = container.querySelectorAll(`.${tabId}_open`);
          targets.forEach(t => t.style.display = "block");
          targets.forEach(t => t.classList.add("active"));

          moveBgToTab(tab);
        }

        // 🔥 Recalculate background position on screen resize
        function updateActiveTabBg() {
            const activeTab = container.querySelector(".Tabs_common_inner_new.active");
            if (activeTab) moveBgToTab(activeTab);
        }
        window.addEventListener("resize", debounce(updateActiveTabBg, 150));

        tabs.forEach(tab => {
            tab.addEventListener("click", () => activateTab(tab));
        });

        const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
        if (firstActive) activateTab(firstActive);

        const navMenu = document.querySelector(".menu-list__list-item");

        if(navMenu){
          navMenu.addEventListener("mouseenter", () => {
              const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
              if (firstActive) activateTab(firstActive);
          });
        }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  InitTabs();
});
document.addEventListener("shopify:section:load", () => {
  InitTabs();
});
/* Tab End */

/* Accordian Start */
function initCustomAccordion(root) {
    const scope = root || document;
    scope.querySelectorAll(".accordion").forEach(acc => {
        const items = acc.querySelectorAll("li");

        items.forEach(item => {
            if (item.dataset.accordionBound === "true") return;
            item.dataset.accordionBound = "true";

            const question = item.querySelector(".question");
            const answer = item.querySelector(".answer");

            if (!question || !answer) return;

            // Ensure correct default state
            if (item.classList.contains("open")) {
                answer.style.display = "block";
                answer.style.height = "auto";
            } else {
                answer.style.display = "none";
                answer.style.height = 0;
            }

            question.addEventListener("click", () => {
                const isOpen = item.classList.contains("open");

                // Close all other items
                items.forEach(i => {
                    if (i === item) return;
                    i.classList.remove("open");
                    const a = i.querySelector(".answer");
                    if (a) {
                        a.style.height = a.scrollHeight + "px"; // ensure correct closing start
                        requestAnimationFrame(() => {
                            a.style.transition = "height 300ms ease";
                            a.style.height = "0px";
                        });
                        setTimeout(() => {
                            a.style.display = "none";
                            a.style.removeProperty("transition");
                        }, 300);
                    }
                });

                // If the clicked one was open, just close it
                if (isOpen) {
                    item.classList.remove("open");
                    answer.style.height = answer.scrollHeight + "px";
                    requestAnimationFrame(() => {
                        answer.style.transition = "height 300ms ease";
                        answer.style.height = "0px";
                    });
                    setTimeout(() => {
                        answer.style.display = "none";
                        answer.style.removeProperty("transition");
                    }, 300);
                    return;
                }

                // Otherwise, open it
                item.classList.add("open");
                answer.style.display = "block";
                answer.style.height = "auto";              // get natural height
                const endHeight = answer.scrollHeight + "px";
                answer.style.height = "0px";               // restart animation
                requestAnimationFrame(() => {
                    answer.style.transition = "height 300ms ease";
                    answer.style.height = endHeight;
                });
                // Wait until animation finishes, then scroll
                setTimeout(() => {
                    answer.style.height = "auto";
                    answer.style.removeProperty("transition");

                    // ✅ Scroll ONLY if inside Product_meta_collapsible_main_new
                    const container = item.closest(".Product_meta_collapsible_main_new");
                    if (container) {
                      // Scroll to question AFTER opening
                      const offset = 100; // adjust to your header height
                      const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

                      window.scrollTo({
                          top: y,
                          behavior: "smooth"
                      });
                    }
                }, 300)
            });
        });
    });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */

/* Mobile Header Start */
function mobileMenuHeight() {
  // Get announcement bar height (with margin)
  const announcementBar = document.querySelector(".Announcement_main_new");
  const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

  // Fixed header height
  const headerEl = document.querySelector('.header-section');
  const headerHeight = headerEl ? headerEl.offsetHeight : 56;  // 56 as fallback
  const totalHeight = announcementBarHeight + headerHeight;

  // Update drawer positions
  const menuDrawer = document.querySelector(".menu-drawer");
  const menuBackdrop = document.querySelector(".menu-drawer__backdrop");

  if (menuDrawer) {
    menuDrawer.style.top = totalHeight + "px";
    menuDrawer.style.height = `calc(100% - ${totalHeight}px)`;
  }
  if (menuBackdrop) {
    menuBackdrop.style.top = totalHeight + "px";
  }

  // For elements with [data-scroll-direction="up"]
  const upElements = document.querySelectorAll("[data-scroll-direction='up'], [data-scroll-direction='down']");
  const totalHeightUp = headerHeight - 1;

  upElements.forEach(el => {
    const upMenu = el.querySelector(".menu-drawer");
    const upBackdrop = el.querySelector(".menu-drawer__backdrop");

    if (upMenu) {
      upMenu.style.top = totalHeightUp + "px";
      upMenu.style.height = `calc(100% - ${totalHeightUp}px)`;
    }
    if (upBackdrop) {
      upBackdrop.style.top = totalHeightUp + "px";
    }
  });
}

// Initial run
mobileMenuHeight();

// Recalculate on menu button click
const menuBtn = document.querySelector(".header__icon--menu");
if (menuBtn) {
  menuBtn.addEventListener("click", mobileMenuHeight);
}

// Recalculate on window resize
window.addEventListener('resize', debounce(mobileMenuHeight, 150));
/* Mobile Header End */

/* Megamenu Start */
(function initMegaMenu() {
  const MEGAMENU_ANCHOR_WIDTH = 1850;
  const MEGAMENU_ANCHOR_HEIGHT = 500;
  const MEGAMENU_MIN_HEIGHT = 399;
  const MEGAMENU_MAX_HEIGHT = 660;

  const getMaxMegamenuHeight = () =>
    Math.round(
      Math.min(
        MEGAMENU_MAX_HEIGHT,
        Math.max(MEGAMENU_MIN_HEIGHT, (window.innerWidth * MEGAMENU_ANCHOR_HEIGHT) / MEGAMENU_ANCHOR_WIDTH)
      )
    );

  const menuItems = document.querySelectorAll(".Megamenu_lists_hover_new");
  const megaMenus = document.querySelectorAll(".megamenu_item_open_new");
  const megaRightPanel = document.querySelector(".Megamenu_mainright_new");
  const megaContainer = document.querySelector(".Megamenu_main_new");
  const megaSubmenu = megaContainer?.closest(".Header_menu_mainblock_new");
  const menuContainers = document.querySelectorAll('.menu-list__list-item');

  let hoverTimer = null;
  let lockedSubmenuHeight = 0;

  const lockSubmenuHeight = () => {
    if (!megaSubmenu || lockedSubmenuHeight > 0) return;

    lockedSubmenuHeight = Math.min(megaSubmenu.offsetHeight, getMaxMegamenuHeight());

    if (lockedSubmenuHeight > 0) {
      megaSubmenu.style.height = `${lockedSubmenuHeight}px`;
    }
  };

  menuItems.forEach(el => {
    el.addEventListener("mouseenter", function () {
      const ID = this.getAttribute("menu_id");
      if (!ID) return;

      clearTimeout(hoverTimer);

      hoverTimer = setTimeout(() => {
        lockSubmenuHeight();

        megaMenus.forEach(item => {
          item.classList.remove("show");
        });

        document
          .querySelectorAll(`.${ID}_display`)
          .forEach(item => {
            item.classList.add("show");

            if (megaRightPanel) {
              megaRightPanel.style.height = `${Math.min(item.offsetHeight, getMaxMegamenuHeight())}px`;
            }
          });
      }, 100);

      menuItems.forEach(item => item.classList.remove("active"));
      this.classList.add("active");
    });

    el.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimer);
    });
  });
  menuContainers.forEach(menuContainer => {
    menuContainer?.addEventListener("mouseleave", () => {
      clearTimeout(hoverTimer);
      // Reset mega menus
      megaMenus.forEach(item => item.classList.remove("show"));
      if (megaMenus.length > 0) {
        megaMenus[0].classList.add("show");
      }
      // Reset menu items
      menuItems.forEach(item => item.classList.remove("active"));
      if (menuItems.length > 0) {
        menuItems[0].classList.add("active");
      }
      if (megaRightPanel) {
        megaRightPanel.style.height = "";
      }
    });
  });

  window.addEventListener("resize", debounce(() => {
    lockedSubmenuHeight = 0;
    if (megaSubmenu) megaSubmenu.style.height = "";
    if (megaRightPanel) megaRightPanel.style.height = "";
    lockSubmenuHeight();
  }, 150));
})();
/* Megamenu End */

/* Video Lazy Load */
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".lazy-video");
  const isMobile = () => window.innerWidth <= 750;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      const shouldLoad =
        (video.classList.contains("Mobile_video_new") && isMobile()) ||
        (video.classList.contains("Desktop_video_new") && !isMobile());

      if (!shouldLoad) return;

      // 🔹 PRELOAD when close (even if not visible yet)
      if (entry.intersectionRatio > 0 && !video.dataset.loaded) {
        video.src = video.dataset.src;
        video.preload = "auto";
        video.load();
        video.dataset.loaded = "true";
      }

      // 🔹 PLAY only when visible
      if (entry.isIntersecting) {
        if (video.readyState >= 2) {
          video.play().catch(() => {});
        } else {
          video.addEventListener(
            "loadeddata",
            () => video.play().catch(() => {}),
            { once: true }
          );
        }
      } else {
        // Optional pause
        // video.pause();
      }
    });
  }, {
    threshold: [0, 0.25],
    rootMargin: "400px 0px" // VERY IMPORTANT
  });

  videos.forEach(video => observer.observe(video));
});
/* Video Lazy Load */

/* Header Search */
const emailInput = document.querySelector('.predictive-search-form__header .search-input');
if(emailInput){
  emailInput.addEventListener('input', () => {
    if (emailInput.value.trim() !== '') {
      emailInput.classList.add('typing');
    } else {
      emailInput.classList.remove('typing');
    }
  });
}
/* Header Search */

/* Footer Email */
document.addEventListener("DOMContentLoaded", function () {
  // Replace this with your actual Klaviyo form ID
  const formSelector = ".Footer_innerside_innerright_forms_new";

  // Watch for Klaviyo form to be added to DOM
  if(formSelector){
    const observer = new MutationObserver(() => {
      const form = document.querySelector(formSelector);
      if (form) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.addEventListener("input", function () {
            this.classList.toggle("typing", this.value.trim() !== "");
          });
          observer.disconnect(); // Stop watching once done
          clearTimeout(watchdogTimer);
        }
      }
    });

    // Start observing the body for form injection
    observer.observe(document.body, { childList: true, subtree: true });

    // Kill observer after 15 seconds if form never appears
    const watchdogTimer = setTimeout(() => observer.disconnect(), 15000);
  }
});
/* Footer Email */

/* Filter Drawer */
document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('#filters-drawer dialog');

  if (!dialog) return;

  const toggleScroll = () => {
    if (dialog.hasAttribute('open')) {
      document.body.classList.add('drawer-open');
    } else {
      document.body.classList.remove('drawer-open');
    }
  };

  // Run initially
  toggleScroll();

  // Watch for open/close changes
  const observer = new MutationObserver(toggleScroll);
  observer.observe(dialog, { attributes: true });

  // Also listen to native dialog events (extra safe)
  dialog.addEventListener('close', toggleScroll);
  dialog.addEventListener('cancel', toggleScroll);
});
/* Filter Drawer */

/* Product Grid */
document.addEventListener("click", (e) => {
  const btn = e.target.closest(".Card_grid_view_btn_new");
  if (!btn) return;

  btn.closest(".Product_card_main_new")?.classList.toggle("active");
});
/* Product Grid */

/* Index_information_marquee */
initMarquee('.Index_information_marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* Index_information_marquee */

/* Scrollbar */
  document.querySelectorAll('.simplebar').forEach(el => {
      if (el.dataset.simplebarInitialized) return;

      new SimpleBar(el, {
          autoHide: false
      });

      el.dataset.simplebarInitialized = 'true';
  });
/* Scrollbar */

/* Product Page Script */
function productPageScript(){
  document.querySelectorAll('.Product_media_slider').forEach(el => {
    if (!el.classList.contains('swiper-initialized')) {
      new Swiper(el, {
        loop: true,
        grabCursor: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        /* Scoped to this slider. A bare ".swiper-pagination" selector resolves
           document-wide and returns the FIRST match, so with two carousels on a
           page one steals the other's dots. Falls back to the old behaviour if
           the markup ever moves the dots outside the slider root. */
        pagination: {
          el: el.querySelector(".swiper-pagination") || ".swiper-pagination",
          clickable: true,
        }
      })
    }
  });
  

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".video-mute-toggle");
    if (!btn) return;

    const mediaContainer = btn.closest("deferred-media");
    const video = mediaContainer.querySelector("video");
    const iframe = mediaContainer.querySelector("iframe");

    const muteIcon = btn.querySelector(".icon-mute");
    const unmuteIcon = btn.querySelector(".icon-unmute");

    // HTML5 VIDEO
    if (video) {
      video.muted = !video.muted;

      muteIcon.classList.toggle("hidden", !video.muted);
      unmuteIcon.classList.toggle("hidden", video.muted);
    }

    function toggleIcons() {
      muteIcon.classList.toggle("hidden");
      unmuteIcon.classList.toggle("hidden");
    }

    // FIXED CODE:
    function isIframeMuted(btn) {
      return btn.dataset.muted !== 'false';  // defaults to muted
    }
    function setIframeMuted(btn, val) { btn.dataset.muted = String(val); }


    // YouTube
    const muted = isIframeMuted(btn);
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: muted ? 'unMute' : 'mute' }), '*'
    );
    setIframeMuted(btn, !muted);
    toggleIcons();

  });

  /* Version Drawer */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.version_drawer_open');
    if (!trigger) return;

    const popupClass = trigger.getAttribute('popup_id');
    if (!popupClass) return;

    // close any open popup first
    document.querySelectorAll('.PDP_meta_maindrawer_new.open')
      .forEach(el => el.classList.remove('open'));

    const target = document.querySelector(`.PDP_meta_maindrawer_new.${popupClass}`);
    if (!target) return;

    target.classList.add('open');
    document.body.classList.add('version_drawer_is_open');
  });

  document.addEventListener('click', function (e) {
    const closeTrigger = e.target.closest('.version_drawer_overlay_new, .version_drawer_close');
    if (!closeTrigger) return;

    document.body.classList.remove('version_drawer_is_open');

    document.querySelectorAll('.PDP_meta_maindrawer_new.open')
      .forEach(el => el.classList.remove('open'));
  });
  /* Version Drawer */
}
if (
  document.body.classList.contains('template-product') ||
  document.body.classList.contains('template-bundle') ||
  document.querySelector('.Product_media_slider')
) {
  productPageScript();
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.Product_media_slider')) productPageScript();
});
/* Product Page Script */

/*
document.querySelectorAll('.Index_object_testimonial_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: false,
        spaceBetween: 24,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        centeredSlides: true,
        observer: true,
        observeParents: true,
        freeMode: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        breakpoints: {
            0: {
                freeMode: !1,
                centeredSlides: false,
                spaceBetween: 16
            },
            750: {
                centeredSlides: true,
                spaceBetween: 24
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});
*/
